module.exports = function() {

  return {
    template: require('html/templates/pageTitle'),
    restrict: 'E',
    replace: true
  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/pageTitle.js
 ** module id = 150
 ** module chunks = 1
 **/